import React from 'react';
import {Button, Navbar, NavDropdown} from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import {PAGES, sectionNameForPage, VIEW_SECTIONS} from "../../scripts/constants";
import {mygaSession} from "../../scripts/myga-session";
import headerImg from "../../assets/images/nsre-logo-blue.png";
import headerImgDark from "../../assets/images/nsre-logo.png";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import "./NavBar.css";
import {PageManager} from "../../scripts/page-manager";
import {NassauLog} from "../../scripts/myga-utils";
import TestingToolbar from "../../selenium-front-end/components/TestingToolbar";
import Resources from "../../Resources/Resources";

class NavBar extends React.Component {
  
  // constructor(props) {
  //   super(props);
  // }
  
  pageBtnClicked = (nextPage) => {
    // 2021.08.10.ADivelbiss - now handled by the PageManager
    // mygaSession.clearReturnToPage(); // clear the prev page if any.
    this.props.updatePage(nextPage);
  };
  
  isDashboardFullPage = () => {
    return false; // disabled this due to moving the close button down into the child component
    // return Object.values(PAGES.dashboardFullPages).find(item => item === this.props.currentPage);
  };
  
  renderCloseButton = () => {
    if (this.isDashboardFullPage()) {
      return (
          <div>
            <FontAwesomeIcon className={'test-enabled'} icon={'times'} style={{cursor: 'pointer'}} onClick={() => this.pageBtnClicked(PAGES.pageDashboard)}/>
          </div>
      )
    }
  };
  
  renderMenu = () => {
    const sections = VIEW_SECTIONS;
    const sectionName = this.props.currentPage ? sectionNameForPage(this.props.currentPage) : '';
    const sectionIndex = sections.map(section=>section.name).indexOf(sectionName);
  
    if (!this.isDashboardFullPage()) {
      return (
          <>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="mr-auto">
                <Nav.Link className={'nav-link-dark test-enabled'} onClick={() => this.pageBtnClicked(PAGES.pageDashboard)}>Dashboard</Nav.Link>
                <Nav.Link className={'nav-link-dark test-enabled'} onClick={() => {
                  // 2021.07.14.ADivelbiss - always start on the email login page
                  this.pageBtnClicked(PAGES.pageGuestEmail);
                }}>Apply</Nav.Link>
                {
                  sectionIndex >= 0 && (
                      <NavDropdown title="Application" id="collasible-nav-dropdown">
                        {
                          VIEW_SECTIONS.map((section,index)=>{
                            // 2022.03.24.ADivelbiss - find the first page that is enabled.
                            const page = section.pages.reduce((v,p)=>{
                              return (v!==null) ? v : (PageManager.validateDataForPage(p)===p) ? p : null;
                            },null);
                            // NassauLog(`NavBar: page: ${page}`);
                            const shouldDisable = (page===null);
                            // const page = section.pages[0];
                            // const shouldDisable = (PageManager.validateDataForPage(page)!==page);
                            return (
                                <NavDropdown.Item
                                    key={index}
                                    active={index===sectionIndex}
                                    disabled={shouldDisable}
                                    className={'nav-link-dark test-enabled'}
                                    onClick={() => this.pageBtnClicked(page)}>
                                  {section.label}
                                </NavDropdown.Item>
                            )
                          })
                        }
                      </NavDropdown>
                  )
                }
                <NavDropdown className={"nav-link-dark"} id="collasible-agent-dropdown" title="My Agent">
                  <NavDropdown.Item className={'nav-link-dark test-enabled'} onClick={() => this.pageBtnClicked(PAGES.pageAgentCode)}>
                    Enter Code
                  </NavDropdown.Item>
                  <NavDropdown.Item className={'nav-link-dark test-enabled'} onClick={() => {
                    mygaSession.setCurrentApp(null);
                    this.pageBtnClicked(PAGES.pageDashboard)
                  }}>
                    Clear Application
                  </NavDropdown.Item>
                  <NavDropdown.Item className={'nav-link-dark test-enabled'} onClick={() => {
                    mygaSession.clearMygaSession();
                    this.pageBtnClicked(PAGES.pageDashboard)
                  }}>
                    Clear Session Info
                  </NavDropdown.Item>
                  {/*<NavDropdown.Item onClick={() => this.pageBtnClicked(PAGES.pageScheduleCall)}>*/}
                  {/*  Schedule Call*/}
                  {/*</NavDropdown.Item>*/}
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </>
      )
    }
  };
  
  render() {
    return (
        <div className="navbar-container">
          <Navbar collapseOnSelect expand="md" variant='light' className="">
            <Navbar.Brand className={'py-0'} onClick={() => this.pageBtnClicked(PAGES.pageLanding)} style={{cursor: 'pointer'}}>
              <div className={'nsre-widget-header py-1'} style={{display: 'inline-block'}}>
                <picture>
                  <source
                      srcSet={headerImgDark}
                      media={"(prefers-color-scheme: dark)"}
                  />
                  <img id={'brand-header-img'} src={headerImg} alt={'nsre logo'} className={'test-enabled'} style={{width: '120px', height: 'auto'}}/>
                </picture>
                {/*<img id={'brand-header-img'} src={headerImg} alt={'nsre logo'} className={'test-enabled'} style={{width: '120px', height: 'auto'}}/>*/}
              </div>
            </Navbar.Brand>
            {this.renderCloseButton()}
            {this.renderMenu()}

            {process.env.REACT_APP_TESTING === '1' && (
              <TestingToolbar updatePage={this.pageBtnClicked}/>
            )}

          </Navbar>
        </div>
    );
  }
  
}

export default NavBar;